export default "__VITE_ASSET__hHGAzy4f__"